import {
  CONFIG_CLOSE,
  CONFIG_OPEN,
  CONFIG_LOAD,
  CONFIG_TAB,
  CONFIG_PRODUCT_SERVICE_TAB,
  CONFIG_CHANGE_SETTING,
  PRODUCT_QUANTITY_SET_TOTAL_WEIGHT,
  PRODUCT_QUANTITY_SET_UNIT,
  PRODUCT_QUANTITY_SET_BASE_QUANTITY,
  DELIVERY_CONFIG_SET,
  CONFIGURATOR_SET,
  CONFIG_SELECTION_CUTTING_DETAILS_ADD,
  CONFIG_SELECTION_CUTTING_DETAILS_UPDATE,
  CONFIG_SELECTION_CUTTING_DETAILS_DELETE,
  SET_SALE_QUANTITY,
  CONFIG_SELECTION_COIL_DETAILS_ADD,
  CONFIG_SELECTION_COIL_DETAILS_UPDATE,
  CONFIG_SELECTION_COIL_DETAILS_DELETE,
  ADD_RECOMMENDED_PRODUCT,
  REMOVE_RECOMMENDED_PRODUCT,
  UPDATE_RECOMMENDED_PRODUCT_QUANTITY,
} from '../Actions/Configurator.action';

let initialState = {
  selectedProductServiceTab: 0,
  selectedRecommendedProducts: [],
  selections: {
    isConfigured: false,
    cuttingDetails: [
      {
        id: 1,
        quantity: 1,
        length: 0,
        cutType: {},
        marking: {},
      },
    ],
    coilDetails: [
      {
        id: 1,
        quantity: 1,
        length: 0,
        foilingCoils: '',
        packingCoils: '',
        maxHeightCoils: 0,
        maxWeightCoils: 0,
      },
    ],
  },
};

export const configurator = (state = initialState, action) => {
  switch (action.type) {
    case CONFIG_CLOSE:
      return {
        ...state,
        id: '',
        orderRow: null,
      };
    case CONFIG_LOAD:
    case CONFIG_CHANGE_SETTING:
    case PRODUCT_QUANTITY_SET_TOTAL_WEIGHT:
    case PRODUCT_QUANTITY_SET_UNIT:
    case PRODUCT_QUANTITY_SET_BASE_QUANTITY:
    case SET_SALE_QUANTITY:
      return {
        ...state,
        ...action.payload,
      };
    case CONFIG_TAB:
      return {
        ...state,
        selectedTab: action.payload,
        selectedProductServiceTab: 0,
      };
    case CONFIG_PRODUCT_SERVICE_TAB:
      return {
        ...state,
        selectedProductServiceTab: action.payload,
      };
    case CONFIG_OPEN:
      return {
        ...state,
        ...action.payload,
      };
    case DELIVERY_CONFIG_SET:
      return {
        ...state,
        deliveryDetails: {
          ...state.deliveryDetails,
          ...action.payload,
        },
      };
    case CONFIGURATOR_SET:
      return {
        ...state,
        selections: {
          ...state.selections,
          ...action.payload,
          isConfigured: true,
        },
      };
    case CONFIG_SELECTION_CUTTING_DETAILS_ADD:
      return {
        ...state,
        selections: {
          ...state.selections,
          cuttingDetails: [
            ...state.selections.cuttingDetails,
            {
              id: state.selections.cuttingDetails.length + 1,
              quantity: 1,
              length: 0,
              cutType: {},
              marking: {},
            },
          ],
        },
      };
    case CONFIG_SELECTION_CUTTING_DETAILS_UPDATE:
      return {
        ...state,
        selections: {
          ...state.selections,
          cuttingDetails: state.selections.cuttingDetails.map((data) =>
            data.id === action.payload.id
              ? { ...data, [action.payload.field]: action.payload.value }
              : data
          ),
        },
      };
    case CONFIG_SELECTION_CUTTING_DETAILS_DELETE:
      return {
        ...state,
        selections: {
          ...state.selections,
          cuttingDetails: state.selections.cuttingDetails.filter(
            (data) => data.id !== action.payload
          ),
        },
      };
    case CONFIG_SELECTION_COIL_DETAILS_ADD:
      return {
        ...state,
        selections: {
          ...state.selections,
          coilDetails: [
            ...state.selections.coilDetails,
            {
              id: state.selections.coilDetails.length + 1,
              quantity: 1,
              length: 0,
              foilingCoils: '',
              packingCoils: '',
              maxHeightCoils: 0,
              maxWeightCoils: 0,
            },
          ],
        },
      };
    case CONFIG_SELECTION_COIL_DETAILS_UPDATE:
      return {
        ...state,
        selections: {
          ...state.selections,
          coilDetails: state.selections.coilDetails.map((data) =>
            data.id === action.payload.id
              ? { ...data, [action.payload.field]: action.payload.value }
              : data
          ),
        },
      };
    case CONFIG_SELECTION_COIL_DETAILS_DELETE:
      return {
        ...state,
        selections: {
          ...state.selections,
          coilDetails: state.selections.coilDetails.filter(
            (data) => data.id !== action.payload
          ),
        },
      };

    case ADD_RECOMMENDED_PRODUCT:
      return {
        ...state,
        selectedRecommendedProducts: [
          ...state.selectedRecommendedProducts.filter(p => p.articleNumber !== action.payload.articleNumber),
          action.payload,
        ],
      };

    case REMOVE_RECOMMENDED_PRODUCT:
      return {
        ...state,
        selectedRecommendedProducts: state.selectedRecommendedProducts.filter(
          p => p.articleNumber !== action.payload
        ),
      };

    case UPDATE_RECOMMENDED_PRODUCT_QUANTITY:
      return {
        ...state,
        selectedRecommendedProducts: state.selectedRecommendedProducts.map(p =>
          p.articleNumber === action.payload.articleNumber ? { ...p, salesQuantity: action.payload.salesQuantity, quantity: action.payload.salesQuantity } : p
        ),
      };

    default:
      return state;
  }
};
